export function openListDetail(router, route, event) {
    if (event && (event.metaKey || event.ctrlKey)) {
        window.open(router.resolve(route).href, '_blank', 'noopener');
        return;
    }
    router.push(route);
}
